import styled from "styled-components";

type DotsLineProps = {
  width?: string;
};

export default function DotsLine({ width }: DotsLineProps) {
  return <Img src="/images/tackice.jpg" width={width} />;
}

const Img = styled.img<{ width?: string }>`
  &&& {
    width: ${(props) => props.width ?? "auto"};
  }
`;
